import { apiClient } from "../config";

async function getObjectProfile(id: string) {
  const res = await apiClient.get(`/admin/objects/${id}`);
  return res.data;
}

export default getObjectProfile;
